/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */

import { validateActionEvent } from './validateActionEvent';

export function validateUIEvent(event: any): void {
	validateActionEvent(event);
}
